import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { ConfigProvider } from 'antd';
import store, { RootState } from '../store/index';
import { ReactNode } from 'react';

interface ThemeWrapperProps {
    children: ReactNode; // 指定children的类型为ReactNode
}

const ThemeWrapper: React.FC<ThemeWrapperProps> = ({ children }) => {
    

    return (
        <ConfigProvider
            theme={{
                components: {
                    Select: {
                        colorPrimary: '#0d8c6d',
                        colorText:'#33364b',
                        fontSizeIcon: 10,
                        fontSizeLG: 10,
                        fontSize: 12,
                        // optionActiveBg:themeColor,
                    },
                    Button: {
                        defaultBg: '#0d8c6d'
                    },
                    Input: {
                        activeBorderColor: '#0d8c6d',
                        activeShadow: '#0d8c6d',
                        colorIconHover: '#0d8c6d', 
                        hoverBorderColor: '#0d8c6d',
                        addonBg:'#0d8c6d',
                        colorIcon: '#0d8c6d',
                    }
                },
                token: {
                    colorPrimary: '#0d8c6d',
                    borderRadius: 2,
                    colorBgContainer: '#ffffff',
                },
            }}
        >
            {children}
        </ConfigProvider>
    );
};

export default ThemeWrapper;